var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDlDone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#78d887",
    d: "M8.079 15.993a2.045 2.045 0 01-1.635-.605L.605 9.478a2.107 2.107 0 010-2.955 2.046 2.046 0 012.919 0l4.557 4.612L18.481.613a2.047 2.047 0 012.919 0 2.107 2.107 0 010 2.955L9.723 15.389a2.046 2.046 0 01-1.46.612q-.091-.001-.184-.008z"
  })));
}
export default SvgDlDone;